"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BipaAgreementResponseToJSON = exports.BipaAgreementResponseFromJSONTyped = exports.BipaAgreementResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
function BipaAgreementResponseFromJSON(json) {
    return BipaAgreementResponseFromJSONTyped(json, false);
}
exports.BipaAgreementResponseFromJSON = BipaAgreementResponseFromJSON;
function BipaAgreementResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'content': !runtime_1.exists(json, 'content') ? undefined : json['content'],
        'isPresent': !runtime_1.exists(json, 'isPresent') ? undefined : json['isPresent'],
    };
}
exports.BipaAgreementResponseFromJSONTyped = BipaAgreementResponseFromJSONTyped;
function BipaAgreementResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'content': value.content,
        'isPresent': value.isPresent,
    };
}
exports.BipaAgreementResponseToJSON = BipaAgreementResponseToJSON;
//# sourceMappingURL=BipaAgreementResponse.js.map